import get from 'lodash/get';
import { AUTOPLAY_GUIDE_ID } from '../constants/categories';

const NAMESPACE = 'categories';

export const selectAutoPlayCategory = (state) =>
  get(state, [NAMESPACE, AUTOPLAY_GUIDE_ID]);
